import { parseGhinHandicapIndex } from './handicapUtils';

import type Person from '../types/Person';

/**
 * Fields denormalized from a Person doc onto a Membership doc whenever a client
 * mutator creates a Membership directly (god/admin paths — see useOrgMutators.addOrg
 * and useMembershipMutators.addOrgMembership). Mirrors what the server-side
 * generateMembership() helper (functions/src/org/utils/generateMembership.ts) does
 * for invitation-based membership creation, so both code paths stay in sync.
 */
export interface DenormalizedProfileFields {
  email?: string;
  picture: string | null;
  ghin?: string;
  ghinIndex?: number;
}

export function denormalizeProfileFields(person: Person): DenormalizedProfileFields {
  const ghinIndex = person.index ? parseGhinHandicapIndex(person.index) : undefined;

  return {
    email: person.email,
    picture: person.picture ?? null,
    ...(person.ghin !== undefined ? { ghin: person.ghin } : {}),
    ...(ghinIndex !== undefined && !isNaN(ghinIndex) ? { ghinIndex } : {}),
  };
}
